// Base code is from https://github.com/jonbern/fetch-retry (original refetch package we used)

function getNewDelay(delay, delayFactor = 1, numTimes) {
  const delayInSec = delay / 1000;

  return Math.pow(delayInSec, delayFactor * (numTimes + 1)) * 1000;
}

export default function retryFetch(url, options) {
  const retries = (options && options.retries) || 0;
  const retryDelay = (options && options.retryDelay) || 1000;
  let retryOn = [];
  let attemptCounter = 0;
  const delayFactor = (options && options.delayFactor) || 1;

  if (options && options.retryOn) {
    if (options.retryOn instanceof Array) {
      retryOn = options.retryOn;
    } else {
      throw {
        name: 'ArgumentError',
        message: 'retryOn property expects an array',
      };
    }
  }

  return new Promise((resolve, reject) => {
    const wrappedFetch = n => {
      fetch(url, options)
        .then(response => {
          if (retryOn.indexOf(response.status) === -1) {
            resolve(response);
          } else if (n > 0) {
            retry(n);
          } else {
            resolve(response);
          }
        })
        .catch(error => {
          if (n > 0) {
            retry(n);
          } else {
            reject(error);
          }
        });
    };

    function retry(n) {
      const delayBeforeNextCall = getNewDelay(
        retryDelay,
        delayFactor,
        attemptCounter
      );
      attemptCounter++;
      setTimeout(() => {
        wrappedFetch(n - 1);
      }, delayBeforeNextCall);
    }

    wrappedFetch(retries);
  });
}
